const compactSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '32px',
      height: '32px',
      fontSize: '0.875rem',
      backgroundColor: 'white'
    }),
    valueContainer: (base) => ({
      ...base,
      height: '32px',
      padding: '0 8px'
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '32px',
        backgroundColor: 'transparent'
      }),
    option: (base, state) => ({
      ...base,
      fontSize: '0.875rem',
      backgroundColor: state.isFocused ? '#f3f4f6' : 'white',
      color: '#111827'
    })
  };

  export default compactSelectStyles;
